import React, { useState } from 'react'
import TextCard from './TextCard'
import Card from '../Reusable/Card'
import DateRangePicker from '../Reusable/DateRrangePicker'
import ComboboxInput from '../Reusable/Form/ComboboxInput'
import { useForm } from 'react-hook-form'
import APIS from '../../constant/EndPoint'
import useGetHook from '../../customHooks/useGetHook'
import Spinner from '../Reusable/Spinner'
import DataTable from '../Reusable/DataTable'
import NACell from '../Reusable/DataTable/NACell'

const Dashboard = () => {
  const [isFilterVisible, setFilterVisiable] = useState(false)
  const {
    register,
    setValue,
    getValues,
    watch,
    clearErrors,
    formState: { errors },
  } = useForm();
  const { data: serverData, isLoading } = useGetHook({
    queryKey: ["grid-report"],
    url: APIS.GRID_REPORT,
    params: {},
  });

  const defaultColumns: any = [
    {
      header: "S.N",
      accessorKey: ".",
      cell: ({ row }: any) => <>{row?.index + 1}</>,
    },
    {
      header: "Name",
      accessorKey: "name",
      cell: NACell,
    },
    {
      header: "Total Order",
      accessorKey: "total_orders",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            {getValue()}
          </>
        )
      },
    },
    {
      header: "Percentage",
      accessorKey: "order_percentage",
      cell: NACell
    },
    {
      header: "Total COD",
      accessorKey: "order_cod",
      cell: NACell

    },
  ];

  return (
    <div className='mb-[50px]'>
      <Card
        onClick={() => setFilterVisiable(!isFilterVisible)}
        title='Filter'
      >
        <>
          {isFilterVisible &&
            <div className='grid grid-cols-1 md:grid-cols-3 gap-x-8'>
              <ComboboxInput
                url={APIS.RIDER}
                queryKey={"rider"}
                register={register("rider")}
                errors={errors?.rider}
                name={"rider"}
                label={"Rider"}
                setValue={setValue}
                placeholder={"Select Rider"}
                getValues={getValues}
                clearErrors={clearErrors}
              />
              <ComboboxInput
                url={APIS.MERCHANT}
                queryKey={"merchant"}
                register={register("merchant")}
                errors={errors?.merchant}
                name={"merchant"}
                label={"Vendor"}
                setValue={setValue}
                placeholder={"Select Vendor"}
                getValues={getValues}
                clearErrors={clearErrors}
              />
              <DateRangePicker
                label={"Select Date Range"}
                setValue={setValue}
                name={"created__range"}
                getValues={getValues}
              />
            </div>
          }
        </>
      </Card>
      {isLoading ? <Spinner /> :
        <>
          <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-x-8'>
            <TextCard title={"Today's Order"} slug={"test"} />
            <TextCard title={"Today's Order"} slug={"test"}/>
            <TextCard title={"Today's Order"} slug={"test"}/>
            <TextCard title={"Today's Order"} slug={"test"}/>
            <TextCard title={"Today's Order"} slug={"test"} />
            <TextCard title={"Today's Order"} slug={"test"}/>
            <TextCard title={"Today's Order"} slug={"test"}/>
            <TextCard title={"Today's Order"} slug={"test"}/>

          </div>

          <DataTable
            url={APIS.STATUS}
            queryKey={"status"}
            columns={defaultColumns}
            tableName={"Status"}
          />
          {/* <div className='grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2	gap-x-8'>
            <Order />
            <Earning />
            <MerchantOnboard />
            <OrderByStatus />
          </div>
          <BranchWiseDeliveryStatus /> */}
        </>
      }
    </div>

  )
}

export default Dashboard
